<template>
    <ValidationProvider :vid="id" rules="checked" v-slot="{ failedRules }" slim>
      <input type="checkbox" id="is-a-captcha-valid" class="d-none" name="isACaptchaValid" v-model="reCaptchaValid" />
      <vue-recaptcha
        v-if="reCaptchaEnabled"
        :sitekey="reCaptchaKey"
        @verify="reCaptchaValid = true"
        @error="reCapchaValid = false"
        @expired="reCapchaValid = false"
        :language="currentLanguege"
        :recaptchaHost="isChina ? 'recaptcha.google.cn' : 'google.com'"
      />
      <div v-if="failedRules.checked" class="field__error red text-danger">
        <div>{{ translate('sbThisIsRequired') }}</div>
      </div>
    </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { mapState } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'
export default {
  name: 'Recaptcha',
  components: {
    ValidationProvider,
    VueRecaptcha
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isChina: Boolean
  },
  data() {
    return {
      reCaptchaValid: false
    }
  },
  computed: {
    ...mapState(['currentLanguege', 'reCaptchaEnabled'])
  },
  created() {
    this.reCaptchaKey = window.reCaptchaKey || process.env.VUE_APP_RECAPTCHA_KEY
  },
  mounted() {
    this.reCaptchaValid = !this.reCaptchaEnabled
  }
}
</script>
